import axios from "axios";
import { localStorageAuthUserData } from "../helper/commanFunc";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.dinezi.com";

export const apiRequest = async (endpoint, method = "GET", data = undefined,isFormData = false, params = null  ) => {
  const { token, role } = localStorageAuthUserData();

  // const storedToken = token || localStorageAuthUserData()?.token;

  const headers = {
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };

  if (token) headers["Authorization"] = `Bearer ${token}`;

  const config = {
      url: `${API_BASE_URL}${endpoint}`,
      method,
      headers,
      params,
  };

  if (data !== undefined) {
      config.data = data;
  }

  try {
      const response = await axios(config);
      return response?.data;
  } catch (error) {

    if(error?.response?.data?.error === 'Forbidden: Token expired'){
        localStorage.clear()
        window.location.href="/login"
    }

      throw error;
  }
};
